import { Stars } from "./Stars";
import { TestimonialCard } from "./Cards";

export const TestimonialsSection = ({ testimonials }) => {
  const featured = testimonials.find((t) => t.featured);
  const rest = testimonials.filter((t) => !featured || t.id !== featured.id);
  const rated = testimonials.filter((t) => t.rating > 0);
  const avg = rated.length ? (rated.reduce((s, t) => s + t.rating, 0) / rated.length) : 0;
  return (
    <section id="testimonials" data-testid="testimonials-section" className="pb-24 scroll-mt-10">
      <div className="bg-white/70 backdrop-blur border border-white/60 rounded-3xl shadow-[0_8px_40px_rgba(26,46,38,0.08)] p-8 md:p-10">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-accent mb-3">Testimonials</p>
            <h2 className="font-serif font-light text-3xl md:text-4xl tracking-tight">Stories of transformation.</h2>
          </div>
          {avg > 0 && (
            <div data-testid="testimonials-average" className="flex items-center gap-3 rounded-2xl border border-border bg-background/60 px-5 py-3">
              <span className="font-serif text-3xl leading-none">{avg.toFixed(1)}</span>
              <div>
                <Stars value={Math.round(avg)} size={16} />
                <p className="text-xs text-muted-foreground mt-1">{rated.length} rating{rated.length > 1 ? "s" : ""}</p>
              </div>
            </div>
          )}
        </div>
        {featured && <div className="mb-6"><TestimonialCard t={featured} featured /></div>}
        {rest.length > 0 && (
          <div className="grid md:grid-cols-2 gap-5 max-h-[70vh] overflow-y-auto pr-2" data-testid="testimonials-list">
            {rest.map((t) => <TestimonialCard key={t.id} t={t} />)}
          </div>
        )}
      </div>
    </section>
  );
};
